import Header from '../../../../components/Header';
import { accountNavigation } from '../../../../navigation/account';
import { headerLink } from '../../../../navigation/function';
import UserRecertification from '../../../../components/Users/certification/recertification';

export default function Recertification() {
    const accountLink = headerLink(accountNavigation.account);
    const certificationLink = headerLink(accountNavigation.certification);
    const pageLink = headerLink(accountNavigation.reCertification, true);

    return (
        <div>
            <Header>
                <div>
                    Members | {accountLink} | {certificationLink} | {pageLink}
                </div>
            </Header>

            <UserRecertification />
        </div>
    );
}
